// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"e01c41d7","145":"4a8ad2a9","154":"a417d26b","527":"ae61591b","549":"6ff5c561","638":"32e68576","682":"1b656e65","852":"52a37d91","960":"4b4e253f"}[chunkId] + ".chunk.js";
};